import { trigger } from '@angular/animations';
import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy, inject, signal } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subject, takeUntil, tap, timer } from 'rxjs';
import { moveLeftIf } from '../../../animations/move-left.if.animation';
import { RatingsService } from '../../../services/ratings.service';
import { InputFieldComponent } from '../../../shared-extra/components/input-field/input-field.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { TooltipDirective } from '../../../shared/directives/tooltip.directive';
import { RatingsPipe } from '../../pipes/ratings.pipe';

@Component({
  selector: 'app-rating',
  templateUrl: './rating.component.html',
  styleUrl: './rating.component.scss',
  animations: [trigger('rating', moveLeftIf)],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AsyncPipe,
    ButtonDirective,
    SvgComponent,
    TooltipDirective,
    InputFieldComponent,
    FormsModule,
    ReactiveFormsModule,
    RatingsPipe,
  ],
})
export class RatingComponent implements OnDestroy {
  private ratingService = inject(RatingsService);
  destroyed$ = new Subject<void>();
  ratingToast$ = this.ratingService.rateToast$.pipe(
    takeUntil(this.destroyed$),
    tap(() => {
      this.rated.set(false);
      this.textMode.set(false);
      this.animate.set(false);
      this.starRating.set(0);
    })
  );
  stars = [1, 2, 3, 4, 5];
  starRating = signal(0);
  rated = signal(false);
  textMode = signal(false);
  animate = signal(false);
  submitting = signal(false);
  form = new FormGroup({
    message: new FormControl('', [Validators.required]),
  });

  close(ratingName: string) {
    this.ratingService.hideRatingOption(ratingName);
  }

  submitText(ratingName: string) {
    if (!this.form.valid) return;
    if (this.submitting()) return;
    this.submitting.set(true);
    this.ratingService.rate(ratingName, this.starRating(), this.form.value.message);
    this.rated.set(true);
  }

  rate(ratingName: string, rating: number) {
    if (rating <= 3) {
      this.rated.set(true);
      this.textMode.set(true);
    } else {
      this.ratingService.rate(ratingName, rating);
      this.animate.set(true);
      timer(750).subscribe(() => {
        this.rated.set(true);
      });
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
